/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/

import * as actions from ".";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { Edits, AppConfig, LoadStatus } from "../../../types";

export interface UseWithApp {
  app: AppConfig | undefined;
  appEdits: Edits<AppConfig>;
  appLoadStatus: LoadStatus;
  loadApp: () => Promise<AppConfig>;
  updateApp: (newData: Partial<AppConfig>) => Promise<AppConfig>;
  revertApp: () => Promise<AppConfig>;
}

export default function useWithApp(): UseWithApp {
  const { app, appLoadStatus, appEdits } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();

  async function loadApp(): Promise<AppConfig> {
    return await dispatch(actions.loadApp()).unwrap();
  }

  async function updateApp(data: Partial<AppConfig>): Promise<AppConfig> {
    return await dispatch(actions.updateApp(data)).unwrap();
  }

  async function revertApp(): Promise<AppConfig> {
    return await dispatch(actions.revertApp()).unwrap();
  }

  return {
    app,
    appEdits,
    appLoadStatus,
    loadApp,
    updateApp,
    revertApp,
  };
}
